import React, { Component } from 'react'
import { Container } from 'react-bootstrap';
import Home from './components/Home.js'
import '../styles/index.scss'

function App() {
  return (
    <Container>
      <Home />
    </Container>
  );
}

export default App;
